import { render, staticRenderFns } from "./OrderActions.vue?vue&type=template&id=87e5d810&scoped=true"
import script from "./OrderActions.vue?vue&type=script&lang=js"
export * from "./OrderActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e5d810",
  null
  
)

export default component.exports